import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { MembershipRuleTypes } from '@guryou/core';

const useMembershipRuleTypes = () => {
  const { t } = useTranslation();
  const [levels, setLevels] = useState();
  const defaultValues = [
    { name: t('MEMBERSHIP_RULES.reservationLimit'), value: MembershipRuleTypes.reservationLimit },
    { name: t('MEMBERSHIP_RULES.subscriptionLimit'), value: MembershipRuleTypes.subscriptionLimit },
    { name: t('MEMBERSHIP_RULES.cancelReservationLimit'), value: MembershipRuleTypes.cancelReservationLimit },
    { name: t('MEMBERSHIP_RULES.cancelSubscriptionLimit'), value: MembershipRuleTypes.cancelSubscriptionLimit },
    // { name: t('MEMBERSHIP_RULES.cancelPeriod'), value: MembershipRuleTypes.cancelPeriod },
    { name: t('MEMBERSHIP_RULES.accessLimit'), value: MembershipRuleTypes.accessLimit },
    { name: t('MEMBERSHIP_RULES.accessPeriod'), value: MembershipRuleTypes.accessPeriod },
    { name: t('MEMBERSHIP_RULES.accessDayOfWeek'), value: MembershipRuleTypes.accessDayOfWeek },
    { name: t('MEMBERSHIP_RULES.access247'), value: MembershipRuleTypes.access247 },
  ];
  if (!levels) {
    setLevels(defaultValues);
  }
  return levels;
};
export { useMembershipRuleTypes };
